<template>
    <div class="order-rank f-fl">
        <RcclCheckBox 
        v-on:onChanged="shorexBookingSelected"
        :defaultChecked="isSelected"
        />
        <div class="order-check">
            <div class="custom-order">
                订单号：{{booking.bookingId}}
            </div>
            <div class="custom-info">
                乘客信息：{{getGuestName(booking)}}
            </div>
        </div>
    </div>
</template>

<script>
const RcclCheckBox = () => import('@/components/Common/RcclCheckBox')
export default {
    name: "ShorexBookingItem",
    components: {
        RcclCheckBox
    },
    props: {
        booking: {
            type: Object
        },
        shorex: {
            type: Object
        },
        onShorexBookingSelected: {
            type: Function
        },
        isSelected: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    methods: {
        getGuests (booking) {
            return booking.bookingGuests || []
        },
        getGuestName (booking) {
            let guestName = []
            const guests = this.getGuests(booking)
            guests.forEach((guest) => {
                let name = guest.chineseLastName + guest.chineseFirstName
                if (!name || name.length == 0) {
                    name = `${guest.pinYinLastName} ${guest.pinYinFirstName}`
                }
                guestName.push(name)
            })
            return guestName.join(' | ')
        },
        shorexBookingSelected (isChecked) {
            this.onShorexBookingSelected(isChecked, this.shorex, this.booking)
        }
    }
}
</script>

<style lang="less" scoped>
.order-rank {
    display: flex;
    margin-right: 18px;
    .order-check {
        margin-left: 8px;
        padding-right: 20px;
        .custom-order {
            font-size: 15px;
            font-weight: 500;
            color: #282b2c;
        }
        .custom-info {
            font-size: 13px;
            color: #747d80;
            font-weight: 500;
            margin-top: 5px;
        }
    }
}
.order-rank:last-child .order-check {
    background: none;
}
</style>